export const NOOP = () => null;
